<template>
  <div
      class="setting-field"
      :class="{'disable-html-component': missing}">
    <el-badge
        value="error"
        class="label"
        :hidden="!missing">
      <label> {{ label }} </label>
    </el-badge>
    <el-select
        v-model="value"
        placeholder="Select"
        size="small"
        :allow-create="allowCreate"
        :filterable="allowCreate"
        :disabled="disabled">
      <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value" />
    </el-select>
  </div>
</template>

<script>
import { keys, every, has, set, isArray, isNumber, get } from "lodash";

export default {
  name: "SelectSetting",
  props: {
    config: {
      type: Object,
      required: true,
      validator: function (object) {
        let result = false;
        const propertiesOk = every(["label", "value", "path", "input"], (k) =>
          has(object, k)
        );
        if (propertiesOk && isArray(object.input.options)) {
          result = every(["label", "value"], (k) =>
            has(object.input.options[0], k)
          );
        }
        // if (!result) console.error("Validation Failed", object);
        return result;
      },
    },
  },
  computed: {
    isAdmin() {
      return this.$store.getters["auth/isAdmin"];
    },
    value: {
      get() {
        const v = this.config.value;
        return isArray(v) ? v.join(",") : v;
      },
      set(value) {
        if (isArray(this.config.value)) {
          value = value.split(",");
        }
        this.onChange(value);
      },
    },
    label() {
      return this.config.label;
    },
    onlyApp() {
      return !this.config.ringApp;
    },
    options() {
      const ops = this.config.input.options;
      return ops.map((o) => {
        return {
          value: isArray(o.value) ? o.value.join(",") : o.value,
          label: o.label,
        };
      });
    },
    path() {
      return this.config.path;
    },
    allowCreate() {
      return this.config.input.allow_create;
    },
    missing() {
      return get(this, "config.missing", false);
    },
    show() {
      return !get(this, "config.removed", false);
    },
    disabled() {
      return !this.isAdmin || get(this, "config.disabled", false);
    },
  },
  methods: {
    isArray() {
      return isArray(this.config.value);
    },
    onChange(value) {
      const payload = set({}, this.path, value);
      this.$emit("change", {
        payload,
        done: () => (this.config.value = value),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "settings";
@include settingField();
</style>
